export default __webpack_public_path__ + "static/media/dslt.038305e6.png";